<template>
   <a-card :bordered="false">
       <a-button type="primary" v-has:addClassification="()=>{guideType='add';form.name='';form.sort='';showVisible=true}">新建分类</a-button>
       <a-form layout='inline' class="m-t-20">
           <a-form-item label="关键字">
              <a-input v-model:value="search.keyword" placeholder="请输入关键字进行搜索" style="width:300px"></a-input>
           </a-form-item>
           <a-form-item>
              <a-button type="primary" @click="search.page=1;pagination.current=1;getCategory();">搜索</a-button>
           </a-form-item>
       </a-form>
       <a-table class='m-t-20' :pagination='pagination' :loading='loading' bordered rowKey='id' :columns='columns' :data-source='list' @change="changPage">
           <template v-slot:action="{ record }">
                <div>
                    <a-button type="primary" size="small" v-has:editClassification="()=>{getCategoryDetails(record)}">编辑</a-button>
                    <a-button type="primary" size="small" ghost  class="m-l-15" v-has:deleteClassification="()=>{handleDel(record)}">删除</a-button>
                </div>
           </template>
       </a-table>
       <!-- 新建分类 -->
       <a-modal :keyboard="false" :title="guideType=='add'?'新建分类':(guideType=='modify'?'修改排序':'编辑分类')" v-model:visible="showVisible"  @ok="submit" destroyOnClose :width='500'>
           <a-form ref="reForm" :model="form" :rules="rules" :label-col="{span:4,offset:2}" :wrapper-col="{span:20}">
               <a-form-item label="分类名称" required name="name" v-if="guideType!='modify'">
                   <a-input v-model:value="form.name" placeholder="请输入分类名称" :maxlength="4" style="width:260px"></a-input>
                   <span class="m-l-20 s_c999">{{form.name.length || 0}} / 4</span>
               </a-form-item>
                <a-form-item :label="guideType!='modify'?'分类排序':'排序'" :help="guideType=='modify'?'数值越大，分类排序越靠前':''">
                    <a-input-number v-model:value="form.sort" :precision="0" :min="0" placeholder="请输入排序号" style="width:260px"></a-input-number>
                </a-form-item>
           </a-form>
       </a-modal>
   </a-card>
</template>

<script>
import {FormOutlined} from "@ant-design/icons-vue";
import { reactive,ref, toRefs,h,createVNode, onMounted } from 'vue';
import { message,Modal } from "ant-design-vue";
import {getCategoryList,categoryDetails,categoryEdit,categorySort,categoryAdd,categoryDelete} from "@/api/guide"
import { iscode } from '../../../utils/app';
export default{
    setup(){
        const search = ref({
            keyword:'',
            page:1,
            limit:10
        })
        const form = ref({
            name:'',
            sort:0,
            id:''
        })
        const state = reactive({
               pagination:{ 
                 total:0,
                 current:1,
                 pageSize:10,
                 defaultPageSize:10,
                 showSizeChanger:true,
                 pageSizeOptions:['10', '20', '30', '40', '50'], 
                 showQuickJumper:true, 
                 showTotal:(total)=> `共 ${total} 条`,
               },
               list:[],
               loading:false,
               showVisible:false,
               guideType:'add',
               rules:{
                  name:[{required: true,message:'请输入分数名称！'}]
               }
        })
        const columns = [
               {
                 title: "分类",
                 dataIndex: "name",
                 key: "name"
               },
               {
                 title: "排序",
                 dataIndex: "sort",
                 key: "sort",
                 width:140,
                 align:'center',
                 customRender:function({record}){
                        return h('div',null,[
                            record.sort,
                            createVNode(FormOutlined,{
                                class:'m-l-5 s_shou s_c376',
                                onClick:async function(){
                                    form.value = record;
                                    state.guideType = 'modify';
                                     state.showVisible = true;
                                }
                             })
                        ])
                 }
               },
               {
                 title: "礼品数量",
                 dataIndex: "gift_num",
                 key: "gift_num"
               },
               {
                 title: "添加时间",
                 dataIndex: "create_time",
                 key: "create_time"
               },
               {
                 title: "操作",
                 dataIndex: "action",
                 key: "action",
                 slots: { customRender: "action" },
                 width:180
               }
        ]
        const reForm = ref(null)
        const methods= {
            handleDel(record){
            //    console.log(record);
                Modal.confirm({
                 centered: true,
                 title:'提示',
                 content: "确定删除该分类吗？",
                 onOk: async () => {
                   const hide = message.loading("正在加载中...", 0);
                   let res = await categoryDelete({...record}).then((res) => res.data).catch(error => error);
                   setTimeout(hide)
                    if (iscode(res, true)) {
                       methods.getCategory()
                    }
                  }
                });
            },
            changPage(e){
                state.pagination.current = e.current;
                state.pagination.pageSize = e.pageSize;
                search.value.page = e.current;
                search.value.limit = e.pageSize;
                methods.getCategory()
            },
            submit(){
                 reForm.value.validate().then(async ()=>{
      
                    const hide = message.loading("正在加载中...", 0);
                    let res;
                    if(state.guideType=='edit'){
                       res = await categoryEdit({...form.value}).then(res=>res.data);
                    }else if(state.guideType == 'modify'){
                       res = await categorySort({...form.value}).then(res=>res.data);
                    }else{
                        res = await categoryAdd({...form.value}).then(res=>res.data);
                    }
                      setTimeout(hide)
                     if(iscode(res,true)){
                         methods.getCategory()
                         state.showVisible=false;
                     }
                 }).catch(error=>{
                     message.error('完善表单！')
                 })
            },
           async getCategory(){
               state.loading = true;
               state.list = [];
                let res = await getCategoryList({...search.value}).then(res=>res.data);
                state.loading = false;
                if(iscode(res)){
                   state.list = res.data.data || [];
                   state.pagination.total = res.data.total || 0;
                   state.pagination.current = res.data.current_page || 1;
                }else{
                    message.error(res.msg)
                }
            },
           async getCategoryDetails(record){
                const hide = message.loading("正在加载中...", 0);
                state.guideType='edit';
                form.value = {};
                let res = await categoryDetails({id:record.id}).then(res=>res.data);
                setTimeout(hide)
                state.showVisible=true;
                if(iscode(res)){
                  console.log(res)
                  form.value = res.data || {};
                }else{
                    message.error(res.msg)
                }
            }
        }

        onMounted(()=>{
            methods.getCategory();
        })
        return {
            search,
            ...toRefs(state),
            columns,
            ...methods,
            form,
            reForm
        }
    }
}
</script>
